export default __webpack_public_path__ + "static/media/5.46b37290.jpg";